import { IApplicationState } from '../../types/redux';

export function selectNewbuildingFlight(state: IApplicationState) {
  return state.dropdown.newbuildingFlight;
}
